import { supabase } from "../supabase";

export const COLLECTION_CREATE_RESULT = Object.freeze({
  CREATED: "CREATED",
  ALREADY_EXISTS: "ALREADY_EXISTS",
});

export async function createCollection({
  name,
  description = null,
  targetAmount,
  currentAmount = 0,
  status = "aktywna",
  schoolYearId,
  externalSource = null,
  externalId = null,
  externalBoxId = null,
  legacyExternalId = null,
  contributionMode = "fixed",
  isVoluntary = false,
  minContribution = null,
  maxContribution = null,
  startDate = null,
  endDate = null,
  affectsClassBalance = true,
}) {
  const { data, error } = await supabase.rpc("create_collection", {
    p_name: name,
    p_description: description,
    p_target_amount: targetAmount,
    p_current_amount: currentAmount,
    p_status: status,
    p_school_year_id: schoolYearId,
    p_external_source: externalSource,
    p_external_id: externalId,
    p_external_box_id: externalBoxId,
    p_legacy_external_id: legacyExternalId,
    p_contribution_mode: contributionMode,
    p_is_voluntary: isVoluntary,
    p_min_contribution: minContribution,
    p_max_contribution: maxContribution,
    p_start_date: startDate,
    p_end_date: endDate,
    p_affects_class_balance: affectsClassBalance,
  });

  if (error) {
    throw error;
  }

  if (!Object.values(COLLECTION_CREATE_RESULT).includes(data)) {
    throw new Error("Nieprawidłowa odpowiedź operacji tworzenia zbiórki.");
  }

  return data;
}
